import { CommonModule } from '@angular/common';
import { Component, HostBinding, Input } from '@angular/core';

export type DecorationType =
  | 'Icon'
  | 'Text'
  | 'Badge'
  | 'Dot'
  | 'Radio'
  | 'Button';

export interface DecorationData {
  icon?: string;
  text?: string;
  color?: string;
  backgroundColor?: string;
  size?: 'Small' | 'Regular' | 'Large';
  type?: DecorationType;
}

@Component({
  selector: 'umss-decoration',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './decoration.component.html',
  styleUrl: './decoration.component.scss'
})
export class UmssDecorationComponent {
  @HostBinding('style.display') display = 'contents';

  /** Content props */
  @Input() decorationData?: DecorationData;
  @Input() icon?: string;
  @Input() text?: string;
  @Input() color?: string;
  @Input() backgroundColor?: string;

  /** Variant props */
  @Input() size: 'Small' | 'Regular' | 'Large' = 'Regular';
  @Input() type: DecorationType = 'Badge';
  @Input() position?:
    | 'TopLeft'
    | 'TopRight'
    | 'BottomLeft'
    | 'BottomRight'
    | 'Center';

  /** State props */
  @Input() disabled: boolean = false;
  @Input() hidden: boolean = false;

  /** Computed properties */
  get displayIcon(): string | undefined {
    return this.decorationData?.icon || this.icon;
  }

  get displayText(): string | undefined {
    return this.decorationData?.text || this.text;
  }

  get displayColor(): string | undefined {
    return this.decorationData?.color || this.color;
  }

  get displayBackgroundColor(): string | undefined {
    return this.decorationData?.backgroundColor || this.backgroundColor;
  }

  get displaySize(): 'Small' | 'Regular' | 'Large' {
    return this.decorationData?.size || this.size;
  }

  get displayType(): DecorationType {
    return this.decorationData?.type || this.type;
  }

  get hasContent(): boolean {
    return !!(this.displayIcon || this.displayText);
  }
}
